```html
<template>
  <div class="health-data-collection">
    <!-- 头部 -->
    <!-- <HeaderModel></HeaderModel> -->
    <!-- 返回按钮 -->
    <div class="back-home" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回首页</span>
    </div>

    <!-- 页面标题 -->
    <h1 class="page-title" ref="pageTitle">健康数据采集</h1>
    <p class="page-subtitle">HEALTH DATA COLLECTION</p>

    <!-- 主要内容卡片 -->
    <div class="content-card">
      <!-- 主描述 -->
      <div class="main-desc">
        使用安睡仪后再次测量，对比数据变化，亲眼见证放松效果。
      </div>

      <!-- 模式卡片网格 -->
      <div class="mode-grid">
        <div v-for="(mode, index) in modes" :key="index" class="mode-card">
          <h3 class="mode-title">{{ mode.title }}</h3>
          <p class="mode-desc">{{ mode.desc }}</p>
          <div class="mode-tags">
            <span
              v-for="(tag, tagIndex) in mode.tags"
              :key="tagIndex"
              class="tag"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </div>

      <!-- 提示框 -->
      <div class="info-box">
        <div class="info-header">
          <img
            class="info-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-17log123.png"
            alt=""
          />
          <span class="info-title">疗愈前数据已保存</span>
        </div>
        <p class="info-desc">
          请在使用完温致安睡仪对应模式后，点击下方按钮“开始采集，见证变化”，通过前后数据对比，便能直观感受到身体的放松变化。
        </p>
      </div>

      <!-- 按钮组 -->
      <div class="button-group">
        <button class="btn-primary" @click="handleStartCollection">
          <img
            class="play-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11caiji2.png"
            alt=""
          />
          <span>开始采集，见证变化</span>
        </button>
        <button class="btn-secondary" @click="handleGenerateReport">
          直接生成报告
        </button>
      </div>
    </div>
    <!-- 页脚 -->
    <FooterModel
      style="position: absolute; bottom: 0; left: 0; right: 0"
    ></FooterModel>
    <!--  -->
    <SelectModelPop ref="SelectModelPop"></SelectModelPop>
  </div>
</template>

<script>
import SelectModelPop from "@/components/SelectModelPop.vue";
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";
export default {
  name: "HealthDataCollectionAfter",
  components: {
    FooterModel,
    SelectModelPop,
    HeaderModel,
  },

  data() {
    return {
      modes: [
        {
          title: "睡眠模式",
          desc: "通过微电流刺激，帮助身体进入深度放松状态，助力夜间休息品质提升。",
          tags: [
            "帮助更快进入休息状态",
            "延长高质量休息时间",
            "提升整体睡眠感受",
          ],
        },
        {
          title: "解压模式",
          desc: "通过微电流刺激，辅助缓解日常压力感知，增强身心恢复能力。",
          tags: ["减轻紧绷感", "促进情绪放松", "辅助缓解压力感知"],
        },
        {
          title: "舒缓模式",
          desc: "通过微电流刺激，辅助放松紧张区域，优化身体感知体验。",
          tags: ["缓解日常疲劳感", "放松紧张区域"],
        },
        {
          title: "活力模式",
          desc: "通过微电流刺激，辅助提升注意力集中度，优化工作学习状态。",
          tags: ["增强专注持久性", "提升任务执行效率", "带来愉悦工作学习体验"],
        },
      ],
    };
  },
  mounted() {
    // ✅ 确保 DOM 渲染完成后滚动
    this.$nextTick(() => {
      this.scrollToTitle();
    });
  },
  methods: {
    goBack() {
      this.$router.replace("/");
    },
    /**
     * 滚动到标题位置
     */
    scrollToTitle() {
      const titleEl = this.$refs.pageTitle;
      if (titleEl) {
        // 方案 1: 使用 scrollIntoView（简单）
        // titleEl.scrollIntoView({
        //   behavior: 'smooth',  // 平滑滚动
        //   block: 'start'       // 元素顶部对齐视口顶部
        // })

        // 方案 2: 使用 window.scrollTo（更精准，可加偏移）
        const offset = 20; // 额外偏移 20px
        const elementTop =
          titleEl.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementTop - offset,
          behavior: "auto", // 没动画
        });
      }
    },
    handleStartCollection() {
      if (
        Math.floor(Date.now() / 1000) -
          JSON.parse(localStorage.getItem("times")) >
        300
      ) {
        setTimeout(() => {
          this.$refs.SelectModelPop.open();
        }, 200)
      } else {
        this.$pop.open(
          "疗愈时间过短",
          "请至少使用安睡仪设备疗愈5分钟，再进行数据采集"
        );
      }
    },
    handleGenerateReport() {
      // this.$toast.success("生成报告中...");
      this.$router.replace("/NoHealingEffects");
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .health-data-collection {
    min-height: 100vh;
    position: relative;
    width: 100%;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    // padding: 3.75rem 1.25rem;
    padding-bottom: 10rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .back-home {
      width: 68.75rem;
      margin: auto;
      padding-top: 3.75rem;
      margin-bottom: 1.5rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-size: 1.25rem;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 1.625rem;
        height: 1.625rem;
        margin-right: 1.1rem;
      }
    }

    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
    }

    .page-subtitle {
      font-size: 1rem;
      color: #666;
      text-align: center;
      margin-bottom: 3rem;
      letter-spacing: 0.5px;
    }

    .content-card {
      width: 100%;
      max-width: 68.75rem;
      margin: 0 auto;
      background: #fff;
      border-radius: 1.4rem;
      padding: 2rem 3.1875rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 116, 252, 0.2);
      box-sizing: border-box;

      .main-desc {
        font-size: 1.25rem;
        font-weight: 600;
        color: #101424;
        text-align: center;
        margin-bottom: 2rem;
        line-height: 1.6;
      }

      .mode-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        margin-bottom: 1rem;

        .mode-card {
          background: #fff;
          border: 1px solid #e5e5e7;
          border-radius: 1rem;
          padding: 1.5rem 0rem;
          box-sizing: border-box;

          .mode-title {
            font-size: 1.125rem;
            font-weight: 600;
            color: #101424;
            margin-bottom: 0.75rem;
            text-align: center;
          }

          .mode-desc {
            font-size: 0.875rem;
            color: #999;
            line-height: 1.6;
            margin-bottom: 1rem;
            text-align: left;
            min-height: 1.9rem;
            padding-left: 1.5rem;
          }

          .mode-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;

            padding: 0rem 1.5rem;
            .tag {
              background: #e8f4ff;
              color: #0074fc;
              font-size: 0.75rem;
              padding: 0.375rem 0.75rem;
              border-radius: 0.375rem;
              white-space: nowrap;
            }
          }
        }
      }

      .info-box {
        background: #f0f7ff;
        border-radius: 0.75rem;
        padding: 1.25rem;
        margin-bottom: 1rem;

        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;

          .info-icon {
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.5rem;
          }

          .info-title {
            font-size: 1rem;
            font-weight: 600;
            color: #0074fc;
          }
        }

        .info-desc {
          font-size: 0.875rem;
          color: #999;
          line-height: 1.6;
          margin: 0;
        }
      }

      .button-group {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .btn-primary {
          width: 100%;
          height: 3.5rem;
          background: #0074fc;
          border: none;
          border-radius: 0.75rem;
          color: #fff;
          font-size: 1.125rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;

          .play-icon {
            width: 1.25rem;
            height: 1.25rem;
          }

          &:hover {
            background: #0066e0;
          }

          &:active {
            background: #0058c0;
          }
        }

        .btn-secondary {
          width: 100%;
          height: 3.5rem;
          background: #52c41a;
          border: none;
          border-radius: 0.75rem;
          color: #fff;
          font-size: 1.125rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: #45a817;
          }

          &:active {
            background: #3d8f14;
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .health-data-collection {
    min-height: 100vh;
    position: relative;
    width: 100vw;
    background: linear-gradient(160deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    // padding: 3.75rem 1.25rem;
    padding-bottom: 18rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .back-home {
      width: 41.875rem;
      margin-left: 2.25rem;
      margin-bottom: 4rem;
      padding-top: 4rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-weight: 600;
      font-size: 1.75rem;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 1.1rem;
        object-fit: contain;
      }
    }

    .page-title {
      width: 42.375rem;
      margin: 0 auto 0.5rem; /* 与副标题间距较小 */
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
    }

    /* 副标题 */
    .page-subtitle {
      width: 42.375rem;
      margin: 0 auto;
      display: none;
      font-size: 1.2rem;
      color: #9fa1a8;
      text-align: center;
      letter-spacing: 0.1rem;
      font-weight: 400;
    }

    .content-card {
      // width: 100%;
      // max-width: 68.75rem;
      margin: 0 auto;
      // padding: 3.1875rem;
      box-sizing: border-box;

      .main-desc {
        padding: 0rem 5rem;
        padding-top: 2rem;
        font-size: 1.75rem;
        font-weight: 600;
        color: #797b84ff;
        text-align: center;
        // margin-bottom: 3rem;
        line-height: 1.6;
        margin-bottom: 2rem;
      }

      .mode-grid {
        display: flex;
        overflow-x: scroll;
        height: 32.2rem;
        width: 100vw;
        margin-bottom: 0.5rem;
        padding-left: 2.25rem;
        scrollbar-width: none; /* Firefox 专用 */
        -ms-overflow-style: none; /* IE/Edge 旧版 */
        scrollbar-color: transparent transparent;

        // ✅ 关键修复：允许横向滚动
        // touch-action: pan-x;

        // // iOS 兼容
        // -webkit-overflow-scrolling: touch;

        // // 防止滚动穿透
        // overscroll-behavior-x: contain;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }
        .mode-card {
          /* ✅ 固定宽度，不伸缩 */
          flex: 0 0 35rem;

          /* ✅ 可选：滚动时吸附到卡片起始位置 */
          scroll-snap-align: start;

          height: 31rem;
          background: #fff;
          border: 1px solid #9fc9fd;
          border-radius: 1.2rem;
          padding: 1.8rem 2rem;
          margin-right: 2.25rem;

          .mode-title {
            font-weight: bold;
            font-size: 2.25rem;
            color: #101424;
            margin-bottom: 1rem;
            text-align: left;
          }

          .mode-desc {
            font-weight: 400;
            font-size: 1.75rem;
            color: #9fa1a8;
            line-height: 2.8rem;
            margin-bottom: 1rem;
            text-align: left;
            min-height: 2.8rem;
          }

          .mode-tags {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .tag {
              margin-bottom: 1.5rem;
              background: #f0f7ff;
              font-weight: 400;
              font-size: 1.75rem;
              color: #0074fc;
              padding: 0.9rem 1.8rem;
              border-radius: 1.2rem;
              white-space: nowrap;
            }
          }
        }
      }

      .info-box {
        width: 42.375rem;
        background: #f0f7ff;
        border-radius: 1.2rem;
        box-sizing: border-box;
        padding: 2rem;
        margin: auto;
        margin-bottom: 1.5rem;

        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;

          .info-icon {
            width: 2.08333125rem;
            height: 2.08333125rem;
            margin-right: 0.5rem;
          }

          .info-title {
            font-size: 2rem;
            font-weight: bold;
            color: #0074fc;
          }
        }

        .info-desc {
          font-weight: 400;
          font-size: 1.75rem;
          color: #777a84;
          line-height: 3rem;
        }
      }

      .button-group {
        width: 42.375rem;
        margin: auto;
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .btn-primary {
          width: 100%;
          height: 6.5rem;
          background: #0074fc;
          border: none;
          border-radius: 1.5rem;
          color: #fff;
          font-size: 2rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;

          .play-icon {
            display: none;
            width: 1.25rem;
            height: 1.25rem;
          }

          // &:hover {
          //   background: #0066e0;
          // }

          // &:active {
          //   background: #0058c0;
          // }
        }

        .btn-secondary {
          width: 100%;
          height: 6.5rem;
          background: #52c41a;
          border: none;
          border-radius: 1.5rem;
          color: #fff;
          font-size: 2rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: #45a817;
          }

          &:active {
            background: #3d8f14;
          }
        }
      }
    }
  }
}
</style>
```